// src/context/persona/NewPersonaPanel.jsx
//
// v198 — the "Metodo" step of "Nuova persona" (only with the AI aids; without them the manual wizard opens
// directly). Two large choices: "Generala con l'AI" FIRST and marked "Consigliato" — the beginner's path: the AI
// fills every field (advanced ones included) and the user reviews in base view — then "Scrivila tu" (the manual
// wizard). The AI choice is disabled while a job runs. The manual name / market screen moved to
// CreateIdentityStep (the wizard's first step inside PersonaEditor).
import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLORS, RADII } from '../../constants/theme.js';
import { PERSONA_ID_RE, slugify } from './personaModel.js';
import { choiceCard, choiceHint } from './personaStyles.js';

// Re-exported so existing imports from this module keep working.
export { PERSONA_ID_RE, slugify };

const TITLE = { display: 'flex', alignItems: 'center', gap: '8px', fontSize: '15px', fontWeight: 700, color: COLORS.ink };
const BADGE = {
  fontSize: '11px', fontWeight: 600, padding: '2px 8px', borderRadius: RADII.pill,
  background: COLORS.accent, color: COLORS.surface,
};

export default function NewPersonaPanel({ aiBusy = false, onChooseAi, onChooseManual }) {
  const { t } = useTranslation(['context']);
  return (
    <div>
      <h3 style={{ margin: '0 0 16px', fontSize: '16px', fontWeight: 700, color: COLORS.ink }}>
        {t('personas.assist.newChooserTitle')}
      </h3>
      <button
        type="button" disabled={aiBusy} onClick={onChooseAi}
        style={{ ...choiceCard(true), opacity: aiBusy ? 0.6 : 1, cursor: aiBusy ? 'not-allowed' : 'pointer' }}
      >
        <span style={TITLE}>
          {t('personas.assist.newAi')} <span style={BADGE}>{t('personas.assist.newRecommended')}</span>
        </span>
        <span style={{ ...choiceHint, marginTop: '6px' }}>{t('personas.assist.newAiHint')}</span>
      </button>
      <button type="button" onClick={onChooseManual} style={choiceCard(false)}>
        <span style={TITLE}>{t('personas.assist.newManual')}</span>
        <span style={{ ...choiceHint, marginTop: '6px' }}>{t('personas.assist.newManualHint')}</span>
      </button>
    </div>
  );
}
